import { render, staticRenderFns } from "./HomeSectionStarterPack.vue?vue&type=template&id=0535b6ff&scoped=true&"
import script from "./HomeSectionStarterPack.vue?vue&type=script&lang=ts&"
export * from "./HomeSectionStarterPack.vue?vue&type=script&lang=ts&"
import style0 from "./HomeSectionStarterPack.vue?vue&type=style&index=0&id=0535b6ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0535b6ff",
  null
  
)

export default component.exports